// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"203":"19ef8da9","224":"54b66f60","374":"d0e0ae26","382":"71f792d8","478":"f408f90a","659":"b91d1312"}[chunkId] + ".chunk.js";
};